import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
} from '@angular/core';
import { jqxMenuComponent } from 'jqwidgets-ng/jqxmenu';
import { environment } from 'src/environments/environment';

import { MainComponent } from '../main.component';
import { AccionesComponent } from '../../acciones/acciones.component';
import { CloneMenuComponent } from '../../clone-menu/clone-menu.component';
import { EditMenuComponent } from '../../edit-menu/edit-menu.component';
import { AppMenuComponent } from '../../app-menu/app-menu.component';
import { AppMenuEmpComponent } from '../../app-menu-emp/app-menu-emp.component';
import { ModulosMenuComponent } from '../../modulos-menu/modulos-menu.component';
import { AppModuloEmpComponent } from '../../app-modulo-emp/app-modulo-emp.component';
import { UserOptionsComponent } from '../../users/user-options/user-options.component';
import { ApartadosComponent } from '../../apartados/apartados.component';
import { AppApartadosComponent } from '../../app-apartados/app-apartados.component';
import { RolesPermissionsComponent } from '../../roles-permissions/roles-permissions.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit, AfterViewInit {
  @ViewChild('menu', { static: false }) menu: jqxMenuComponent;
  @ViewChild('topContainer', { static: true, read: MainComponent })
  topContainer: MainComponent;
  public closed = false;
  public environment = environment;
  private minimized = false;
  private widthMenuOri = '';
  private widthCenterOri = '';
  private menuSave: any[] = [];
  public menuAL: Array<Object>;
  public menuAux: Array<Object>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    this.menuAL = [
      {
        id: 0,
        text: "<span style='vertical-align: middle;' class='material-icons'>link</span>  Acciones",
        to: '',
      },
      {
        id: 1,
        text: "<span style='vertical-align: middle;' class='material-icons'>settings_applications</span>  Clonar menú",
        to: '',
      },
      {
        id: 2,
        text: "<span style='vertical-align: middle;' class='material-icons'>edit</span>  Editar menú",
        to: '',
      },
      {
        id: 3,
        text: "<span style='vertical-align: middle;' class='material-icons'>assignment</span>  Menús aplicaciones",
        to: '',
      },
      {
        id: 4,
        text: "<span style='vertical-align: middle;' class='material-icons'>menu</span>  Menús app/empresa",
        to: '',
      },
      {
        id: 5,
        text: "<span style='vertical-align: middle;' class='material-icons'>dashboard</span>  Módulos",
        to: '',
      },
      {
        id: 6,
        text: "<span style='vertical-align: middle;' class='material-icons'>dashboard_customize</span>  Módulos app/empresa",
        to: '',
      },
      {
        id: 7,
        text: "<span style='vertical-align: middle;' class='material-icons'>app_registration</span>  Apartados",
        to: '',
      },
      // {
      //   id: 8,
      //   text: "<span style='vertical-align: middle;' class='material-icons'>manage_accounts</span>  Opciones y permisos/rol",
      //   to: '',
      // },
      {
        id: 8,
        text: "<span style='vertical-align: middle;' class='material-icons'>manage_accounts</span> Opciones y permisos/rol",
        to: '',
      },
      // {
      //   id: 10,
      //   text: "<span style='vertical-align: middle;' class='material-icons'>web</span>  Opciones y permisos/app",
      //   to: '',
      // },
    ];

    // Formatear la data como pide Jqwidgets
    let source = {
      datatype: 'json',
      datafields: [
        { name: 'id' },
        { name: 'parentid' },
        { name: 'text' },
        { name: 'icon' },
        { name: 'to' },
      ],
      id: 'id',
      localdata: this.menuAL,
    };

    this.menuAux = this.getAdapter(source).getRecordsHierarchy(
      'id',
      'parentid',
      'items',
      [{ name: 'text', map: 'label' }],
    );
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // Cuando se redimensiona la ventana del navegador
    window.addEventListener('resize', () => {
      const menuContainer = document.getElementById('menu-container');
      if (menuContainer.style.width !== '') {
        const centerContainer = document.getElementById('center-container');
        if (menuContainer.style.width.indexOf('%') < 0) {
          const mc = Number.parseInt(menuContainer.style.width);
          centerContainer.style.width = window.innerWidth - mc + 'px';
        } else {
          centerContainer.style.width = this.widthCenterOri;
        }
      }
    });
    const menuContainer = document.getElementById('menu-container');
    const centerContainer = document.getElementById('center-container');
    if (menuContainer) {
      this.widthMenuOri = menuContainer.style.width;
    }
    if (centerContainer) {
      this.widthCenterOri = centerContainer.style.width;
    }
  }

  getAdapter(source: any): any {
    return new jqx.dataAdapter(source, { autoBind: true });
  }

  goToPage(event) {
    let componentFactory;

    MainComponent.getInstance().destroyComponent();

    switch (parseInt(event.target.id, 10)) {
      case 0:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              AccionesComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      case 1:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              CloneMenuComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      case 2:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              EditMenuComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      case 3:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              AppMenuComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      case 4:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              AppMenuEmpComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;

      case 5:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              ModulosMenuComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      case 6:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              AppModuloEmpComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      case 7:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              ApartadosComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
      // case 8:
      //   componentFactory =
      //     MainComponent.getInstance().topContainer.createComponent(
      //       this.componentFactoryResolver.resolveComponentFactory(
      //         UserOptionsComponent,
      //       ),
      //     );
      //   componentFactory.instance.init(componentFactory);
      //   break;
      case 8:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              RolesPermissionsComponent,
            ),
          );
        // componentFactory.instance.init(componentFactory);
        break;

      case 10:
        componentFactory =
          MainComponent.getInstance().topContainer.createComponent(
            this.componentFactoryResolver.resolveComponentFactory(
              AppApartadosComponent,
            ),
          );
        componentFactory.instance.init(componentFactory);
        break;
    }
  }

  onClose() {
    const menuContainer = document.getElementById('menu-container');
    if (!this.minimized) {
      // Quito los textos del menú para que se pueda minimizar
      const allLiElements =
        this.menu.elementRef.nativeElement.firstElementChild.children[0]
          .children;
      for (let i = 0; i < allLiElements.length; i++) {
        this.menuSave.push(allLiElements[i].innerHTML);
        allLiElements[i].innerHTML = allLiElements[i].innerHTML.substring(
          0,
          allLiElements[i].innerHTML.lastIndexOf('</span>'),
        );
      }
      menuContainer.style.width = '50px';
      const centerContainer = document.getElementById('center-container');
      centerContainer.style.width = window.innerWidth - 50 + 'px';
    } else {
      // Vuelvo a poner los textos del menú originales
      const allLiElements =
        this.menu.elementRef.nativeElement.firstElementChild.children[0]
          .children;
      for (let i = 0; i < allLiElements.length; i++) {
        allLiElements[i].innerHTML = this.menuSave[i];
      }
      const centerContainer = document.getElementById('center-container');
      menuContainer.style.width = this.widthMenuOri;
      centerContainer.style.width = this.widthMenuOri;
    }
    this.minimized = !this.minimized;
    window.dispatchEvent(new Event('resize'));
  }
}
